const data = [
  {
    title: 'Beesco Blue',
    hex: '#00448e',
    pantone: 'PANTONE 302C',
    rgb: 'R0 G68 B142',
  },
  {
    title: 'Beesco Orange',
    hex: '#f8991d',
    pantone: 'PANTONE 298C',
    rgb: 'R248 G153 B29',
  },
  {
    title: 'Beesco Gray',
    hex: '#525d5c',
    pantone: 'PANTONE 425C',
    rgb: 'R82 G93 B92',
  },
  {
    title: 'Beesco Light Gray',
    hex: '#c9cacc',
    pantone: 'PANTONE Cool Gray 4C',
    rgb: 'R201 G202 B204',
  },
];

export default data;
